import { Component, Input, OnInit, forwardRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vb-query-type',
  templateUrl: './query-type.component.html',
  styleUrls: ['./query-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QueryTypeComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class QueryTypeComponent implements OnInit {
  private translate = inject(TranslateService);

  @Input() formControlName: any;
  @Input() element: any;
  @Input() currentPage: any;
  @Input() formData: any;
  @Input() disableField: boolean = false;
  private modelValue: any;
  possibleValues = [
    {
      name: this.translate.instant('MULTIPLE_OPTION'),
      value: 'multiple'
    },
    {
      name: this.translate.instant('SINGLE_OPTION'),
      value: 'single'
    }
  ];
  searchValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    // this.searchValue = value=="multiple"?{
    //   name:"can_return_0_or_1_or_more_records",
    //   value:"multiple"
    // }:{
    //   name:"always_returns_0_or_1_record",
    //   value:"single"
    // };
    this.searchValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }
  ngOnInit(): void {
    console.log('hello');
  }
  handleOptionsClick(event) {
    this.set(this.searchValue);
  }
}
